import React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

//user-level roles (e.g. "admin"), as opposed to PermissionGuard's per-domain resources
const RoleGuard = ({ role, children }) => {
   const { user } = useAuth();
   const roles = (user && user.roles) || [];

   if (!roles.includes(role)) {
      return <Navigate to="/site/dashboard" replace />;
   }

   return <React.Fragment>{children}</React.Fragment>;
};

export default RoleGuard;
